import { gql } from '@apollo/client'

export default gql`
  fragment NationalContractReferenceWithType on NationalContractReferenceWithTypeDTO {
    type
    description
    levels {
      level
      minSalary
      displayOrder
      selectable
    }
  }
`
